import { Component, OnInit, ViewChild } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { SeFeFormService } from 'se-fe-form-service'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { RecaptchaComponent } from 'ng-recaptcha'
import { environment } from '@se-po/shared-environments'

import { PasswordFormCreateService } from './password-form-create.service'
import { PasswordFormSubmitter } from './create-password-submit.service'

@Component({
  selector: 'se-po-household-setup-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss']
})
export class CreatePasswordComponent implements OnInit {

  @ViewChild('captchaRef') public captchaRef: RecaptchaComponent

  public recaptchaKey: string
  public ready = false
  public form: UntypedFormGroup
  public fieldType = 'password'
  public iconName = 'hidden'
  public email = ''

  private readonly app = 'SingleSignOn'
  private readonly page = 'SignUp'
  private readonly label = 'Step2'

  constructor(
    private analyticsService: AnalyticsService,
    private formCreator: PasswordFormCreateService,
    private formService: SeFeFormService,
    private store: StoreService,
    private submitter: PasswordFormSubmitter
  ) { }

  public get unknownError(): boolean {
    return this.submitter.unknownError
  }

  public get submitting(): boolean {
    return this.submitter.submitting
  }

  public set submitting(val: boolean) {
    this.submitter.submitting = val
  }

  public ngOnInit(): void {
    this.submitter.validateAccount(this.store)
    this.initCaptcha()
    this.createForm()
    this.email = this.store?.accountInfo?.email
    this.analyticsService.pageView(this.app, this.page, this.label)
  }

  public toggleFieldType(): void {
    this.fieldType = this.fieldType === 'text' ? 'password' : 'text'
    this.iconName = this.fieldType === 'text' ? 'visible' : 'hidden'
  }

  public submit(): void {
    this.analyticsService.seEvent('SignUpButtonMainClick')
    this.submitting = true
    if (!this.formService.isValid(this.form)) {
      this.analyticsService.trackFormErrors(this.form)
      this.submitting = false
      return
    }

    this.store.patchAccountInfo({ password: this.form.value.password })
    this.submitter.validateAndSubmit(this.store, this.captchaRef)
  }

  public recaptchaResolved(captchaResponse: string): void {
    this.store.captchaResponse = captchaResponse
    this.submitter.submit(this.store)
  }

  public recaptchaErrored(): void {
    this.submitting = false
    this.analyticsService.trackError('CaptchaVerificationFailed.PleaseTryAgain')
  }

  private createForm(): void {
    this.form = this.formCreator.createForm()
    this.ready = true
  }

  private initCaptcha(): void {
    if ((this.store.accountInfo?.email || '').endsWith('@sportngin.com')) {
      this.store.captchaResponse = 'sportngin'
    }
    else {
      this.store.captchaResponse = undefined
      this.recaptchaKey = environment.recaptchaV2SiteKey
    }
  }
}
